import { UpperCasePipe } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { HeaderComponent } from "@components/header/header.component";
import { InfoComponent } from "@components/info/info.component";
import { DivListComponent } from "@components/list/div-list/div-list.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { VKDirektutbyteUtbyteDTO } from "~app/features/virkeskop/models/tradslag/direktutbyte-models";
import { VKSnabbkalkylUtbyteDTO } from "~app/features/virkeskop/models/tradslag/snabbkalkyl-models";

const infoIconProduktgrupper = [
    "Talltimmer",
    "Grantimmer"
];

type TradslagUtbyte = VKSnabbkalkylUtbyteDTO | VKDirektutbyteUtbyteDTO;
type ProduktgruppVolymFunction = (volym: number) => number;
type ProduktgruppVolymStamblockFunction = (produktgruppNamn: string) => number;

@Component({
    selector: "rask-tradslag-utbyte",
    templateUrl: "./tradslag-utbyte.component.html",
    styleUrls: ["./tradslag-utbyte.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        DivListComponent,
        ListColumnDirective,
        InfoComponent,
        UpperCasePipe
    ]
})
export class TradslagUtbyteComponent {
    @Input() readonly = false;
    @Input() utbyte?: TradslagUtbyte;
    @Input() getProduktgruppVolym: ProduktgruppVolymFunction;
    @Input() getProduktgruppVolymStamblock: ProduktgruppVolymStamblockFunction;
    @Input() showInfo?: boolean = false;

    protected showInfoIcon(namn: string) {
        return infoIconProduktgrupper.includes(namn) && this.showInfo;
    }

    protected get summaVolym() {
        let total = 0;

        for(const row of this.utbyte.produktgrupper) {
            total += this.getProduktgruppVolym(row.kvantitetHa);
        }

        return total;
    }

    protected get utbyteTimmerAndel() {
        return this.utbyte.timmerandel;
    }

}
